<template>
  <div>
    <!-- Message -->
    <ValidationProvider
      ref="replyValidationProviderRef"
      name="Field"
      :rules="{
        required: true,
        validChild: true,
      }" >
      <b-form-group>
        <label
          for="text-field"
          class="settings__label flex flex-align-center" >
          Wait for reply for up to
        </label>
        <TimeFrequency
          :ref="'replyRef'"
          v-model="replyTime"
          :min-seconds="flowsDefinitionsUI.logic.CONREP.values.minValue"
          :max-seconds="flowsDefinitionsUI.logic.CONREP.values.maxValue"
          :min-seconds-message="minSecondsMessage" />
        <div class="flex flex-align-center mt-3 description">
          <SBIcon
            id="media-description"
            class="mr-1"
            :icon="SBIconList.INFORMATION"
            :color="SBColors.blackUltralight"
            :size="12" />
          <p>If a contact doesn't reply within a defined time, this flow will end.</p>
        </div>
      </b-form-group>
    </ValidationProvider>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import TimeFrequency from '@/components/common/TimeFrequency';

export default {
  name: 'ContactReplyBlock',
  components: {
    SBIcon,
    TimeFrequency,
  },
  props: {
    node: {
      type: Object,
      required: false,
      default: () => {},
    },
    editMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      replyTime: null,
      minSeconds: 300,
      minSecondsMessage: 'Retrigger period can\'t be less than 1 minute.',
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      loadingNewTemplateConfig: 'notification/loadingNewTemplateConfig',
      newTemplateConfig: 'notification/newTemplateConfig',
      flowsDefinitionsUI: 'flows/flowsDefinitionsUI',
    }),
  },
  mounted() {
    if (this.node && this.editMode) {
      this.replyTime = {
        seconds: this.node.blockData.params.seconds,
      };
    } else {
      this.replyTime = {
        seconds: this.flowsDefinitionsUI.logic.CONREP.values.minValue,
      };
    }
  },
  methods: {
    ...mapActions({
      addFlowBlock: 'flows/addFlowBlock',
      editFlowBlock: 'flows/editFlowBlock',
    }),
    submit(parentId) {
      if (this.$refs.replyValidationProviderRef.validate()) {
        if (!this.editMode) {
          this.addFlowBlock({
            parentId,
            block: {
              category: 'logic',
              type: 'CONREP',
              params: {
                seconds: this.replyTime.seconds,
              },
            },
          })
            .then((response) => {
              if (response.status === 200) {
                this.$emit('finished');
              }
            });
        } else {
          this.editFlowBlock({
            blockId: this.node.id,
            block: {
              category: 'logic',
              type: 'CONREP',
              params: {
                seconds: this.replyTime.seconds,
              },
            },
          })
            .then((response) => {
              if (response.status === 200) {
                this.$emit('finished');
              }
            });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: $blackPrimary !important;
  text-transform: none !important;
}

.description {
  * {
    font-size: 14px;
    font-weight: normal;
    color: $blackUltralight;
  }

  .sb-icon {
    padding-bottom: 2px;
  }
}
</style>
